<template>
	<div class="card border-dark border-2" style="background-color: rgba(var(--x-secondary-rgb), .1) !important;" :class="{ 'placeholder-glow': placeholder }">
		<div class="card-body hstack align-items-start">
			<div class="vstack">
				<div>Ganancia acumulada</div>
				<div class="vstack gap-3 lh-sm">
					<template v-if="placeholder">
						<div class="vstack gap-1 lh-sm">
							<div class="h2 font-bold placeholder col-5"></div>
							<div class="hstack gap-2">
								<span class="badge rounded-pill bg-dark ps-2 placeholder col-3">&nbsp;</span>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="vstack lh-sm" v-if="summaries.length > 0" v-for="(summary, index) in summaries" v-bind:key="index">
							<div class="h2 font-bold">
								{{ vueNumberFormat(summary.amount, { precision: 2 }) }} <span class="text-lg">{{ summary.currency }}</span>
							</div>
							<div class="hstack gap-2">
								<span class="badge rounded-pill bg-success ps-2" v-if="summary.month > 0">+ {{ vueNumberFormat(summary.month, { suffix: ` ${summary.currency}`, precision: 2 }) }}</span>
								<span class="badge rounded-pill bg-warning ps-2" v-else>= {{ vueNumberFormat(summary.month, { suffix: ` ${summary.currency}`, precision: 2 }) }}</span>
								<span class="text-nowrap text-xs text-muted">Este mes</span>
							</div>
						</div>
						<div class="vstack lh-sm" v-else>
							<div class="h2 font-bold">
								{{ vueNumberFormat(0, { precision: 2 }) }}
							</div>
							<div class="hstack gap-2">
								<span class="badge rounded-pill bg-warning ps-2">= {{ vueNumberFormat(0, { precision: 2 }) }}</span>
								<span class="text-nowrap text-xs text-muted">Este mes</span>
							</div>
						</div>
					</template>
				</div>
			</div>
			<div class="pe-3 pt-3 flex-shrink-0">
				<i class="bi bi-coin" style="font-size: 3rem; line-height: 1;"></i>
			</div>
		</div>
		<div class="card-footer border-dark">
			<a href="javascript:void(0);" class="link-primary" @click="select">Ver movimientos<i class="bi bi-chevron-right ps-1 text-xs"></i></a>
		</div>
	</div>
</template>

<script>
	export default {
		emits: ['select'],
		props: {
			summaries: Array,
			placeholder: {
				type: Boolean,
				default: false
			}
		},
		setup(props, { emit }) {
			const select = () => emit('select');

			return { select };
		}
	}
</script>